import { connect } from 'react-redux';
import _ from 'lodash';
import { fetchEmergencyPersonnel } from '../../../actions/emergencyPersonnelActions';
import LeftArea from './LeftArea';
import { translations } from '../../../selectors/translations';
import { emergencyPersonnelSelector, isLoadingSelector } from '../../../selectors/emergencyPersonnel';
import { setSelectedDate, setSelectedPin, setSelectedProductType } from '../../../actions/whiteLabel/booking';

const mapStateToProps = state => {
  return {
    translations: _.get(translations(state), 'emergencyPersonnel', {}),
    formatString: state.translations ? state.translations.formatString : () => {},
    assignedOfficeId: _.get(state.global.get('heroProfile'), 'assignedOfficeId', null),
    emergencyPersonnel: _.get(emergencyPersonnelSelector(state), 'emergencyPersonnel', {}),
    isLoading: isLoadingSelector(state),
  };
};

const mapDispatchProps = dispatch => {
  return {
    fetchEmergencyPersonnel: officeId => dispatch(fetchEmergencyPersonnel(officeId)),
    setSelectedPin: productId => dispatch(setSelectedPin(productId)),
    setSelectedDate: startDate => dispatch(setSelectedDate(startDate, startDate)),
    setSelectedProductType: productType => dispatch(setSelectedProductType(productType)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(LeftArea);
